import * as React from 'react';

function SvgLaybuyColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="LaybuyColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={3}
        y={5}
        width={24}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5h23.998v19.45H3V5z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#LaybuyColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.134 6.747L14.97 8.91c-.15.15-.366 0-.366 0L11.836 6.09a2.296 2.296 0 00-3.237 0 2.294 2.294 0 000 3.237l4.587 4.599a2.294 2.294 0 003.237 0l3.848-3.848.675-.691a1.18 1.18 0 011.67 0c.45.44.457 1.16.017 1.61l-.025.025-.695.699-6.985 6.991a.288.288 0 01-.407.013l-.013-.013-7.602-7.602a2.298 2.298 0 00-3.239 0 2.297 2.297 0 000 3.237l9.479 9.479-.051-.044c.896.89 2.342.89 3.238 0l8.825-8.824.093-.093a5.74 5.74 0 10-8.117-8.118z"
          fill="#786DFF"
        />
      </g>
    </svg>
  );
}

export default SvgLaybuyColourSquare;
